import { render, staticRenderFns } from "./CollectiveSettings.vue?vue&type=template&id=5b1f51c8&scoped=true"
import script from "./CollectiveSettings.vue?vue&type=script&lang=js"
export * from "./CollectiveSettings.vue?vue&type=script&lang=js"
import style0 from "./CollectiveSettings.vue?vue&type=style&index=0&id=5b1f51c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1f51c8",
  null
  
)

export default component.exports